import i18n from "@config/i18n";
import { EnrollmentRestrictionOperator } from "@models/ISchema";

export const getRestrictionOperators = () => {
  return [
    {
      label: i18n.t(
        `group-restrictions.manage-restrictions.form.conditions.${EnrollmentRestrictionOperator.In}`,
      ),
      value: EnrollmentRestrictionOperator.In,
    },
    {
      label: i18n.t(
        `group-restrictions.manage-restrictions.form.conditions.${EnrollmentRestrictionOperator.Nin}`,
      ),
      value: EnrollmentRestrictionOperator.Nin,
    },
  ];
};

export const getRestrictionValue = (restriction: any) => {
  if (restriction?.__typename === "CustomModelValue") {
    return {
      code: restriction?.customModelValueCode ?? "",
      name: restriction?.customModelValueLabel ?? "",
    };
  }

  if (restriction?.__typename === "Modality") {
    return {
      code: restriction?.modalityCode ?? "",
      name: restriction?.modalityName ?? "",
    };
  }

  if (restriction?.__typename === "Program") {
    return {
      code: restriction?.programCode ?? "",
      name: restriction?.programName ?? "",
    };
  }

  if (restriction?.__typename === "Curriculum") {
    return {
      code: restriction?.curriculumCode ?? "",
      name: restriction?.curriculumName ?? "",
    };
  }

  return {
    code: restriction?.code ?? "",
    name: restriction?.name ?? "",
  };
};
